import { useState } from "react";
import Typography from "../../../components/Typography";
import Api from "../../../config";
import PaginatedTable from "../../../components/table/Paginated-table";
import { getJSONheader } from "../../../utils";
import moment from "moment";
import { Link } from "react-router-dom";

export const LAWYER_CAUSELIST_COLUMNS = [
  {
    Header: "S/No.",
    Cell: ({ cell: { row } }: any) => {
      return <span className="text-xs">{Number(row.id) + 1}</span>;
    },
  },
  {
    Header: "Suit Number",
    Cell: ({ cell: { row } }: any) => {
      return (
        <span className="text-xs font-medium text-brand_indigo">
          {row.original?.case_folder?.suit_number || "N/A"}
        </span>
      );
    },
  },
  {
    Header: "Case Title",
    Cell: ({ cell: { row } }: any) => {
      return (
        <span className="text-xs">
          {row.original?.case_folder?.title || row.original?.title || "N/A"}
        </span>
      );
    },
  },
  {
    Header: "Hearing Description",
    accessor: "description",
    Cell: ({ cell: { row } }: any) => {
      return (
        <span className="text-xs">
          {row.original?.description || "N/A"}
        </span>
      );
    },
  },
  {
    Header: "Scheduled Date",
    Cell: ({ cell: { row } }: any) => {
      return (
        <span className="text-xs">
          {row.original?.scheduled_at
            ? moment(row.original.scheduled_at).format("MMM Do YYYY")
            : "N/A"}
        </span>
      );
    },
  },
  {
    Header: "Hearing Type",
    accessor: "type",
    Cell: ({ cell: { row } }: any) => {
      return (
        <span className="text-xs capitalize">
          {row.original?.type || "Physical"}
        </span>
      );
    },
  },
  {
    Header: "Action",
    Cell: ({ cell: { row } }: any) => {
      return (
        <div className="flex items-center gap-2">
          {row.original?.type !== "physical" && row.original?.join_url && (
            <a
              target="_blank"
              href={row.original.join_url}
              className="px-3 py-1 bg-brand_indigo text-white text-xs rounded-md hover:opacity-80"
              rel="noreferrer"
            >
              Join
            </a>
          )}
          {row.original?.case_folder?.id && (
            <Link
              to={`/lawyer/proceed?id=${row.original.case_folder.id}`}
              className="px-3 py-1 bg-gray-100 text-gray-800 text-xs rounded-md hover:bg-gray-200"
            >
              View Case
            </Link>
          )}
        </div>
      );
    },
  },
];

export default function LawyerCauseList() {
  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [isLoading, setLoading] = useState(false);

  const fetchData = async (page: any, pageSize: any) => {
    setLoading(true);
    try {
      const response = await Api.get(
        `/lawyer/cause-lists?page=${page || 1}&per_page=${pageSize || 10}`,
        getJSONheader()
      );
      const resData = response.data;
      setLoading(false);
      setData(resData?.data || []);
      setTotalPages(resData?.meta?.last_page || 1);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching lawyer cause lists:", error);
    }
  };

  return (
    <div className="pt-4 px-8 pb-36 lg:pb-0">
      <div className="flex justify-between items-center mb-6">
        <div>
          <Typography textStyle="text-[20px] font-medium text-black">
            My Cause List
          </Typography>
          <p className="text-xs text-gray-500 mt-1">
            Scheduled hearings for cases you represent
          </p>
        </div>
      </div>
      <div className="w-full pb-20 lg:pb-0">
        <div className="border border-[#F0F0F0] rounded-xl bg-white shadow-sm overflow-hidden">
          <PaginatedTable
            columns={LAWYER_CAUSELIST_COLUMNS}
            data={data}
            totalPages={totalPages}
            fetchData={fetchData}
            isLoading={isLoading}
          />
        </div>
      </div>
    </div>
  );
}
